import React from "react";
import AppRouter from "./routes/AppRouter";
import { useDynamicFavicon } from "./hooks/useDynamicFavicon"; // Sesuaikan folder jika berbeda

export default function App() {
  // Panggil hook dengan status default "online" agar ikon sinyal warna hijau langsung muncul
  useDynamicFavicon("online");

  return <AppRouter />;
}